module.exports = __webpack_public_path__ + "img/725.47ce627c.png";